import axios from 'axios';

export const httpClient = axios.create({
  // baseURL: 'http://192.168.0.206:4548',
  // baseURL: 'http://68.178.174.30:4548',
  baseURL: 'https://pralhadflours.com/apii/',
});

export default httpClient;
